import { apiClient } from "./api.js";

export interface AlertDto {
  id: number;
  specialization: string;
  seniorities: string[];
  languages: string[];
  skills: string[];
  exclusions: { value: string; scope: string }[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateAlertPayload {
  specialization: string;
}

export interface UpdateAlertPayload {
  seniorities?: string[];
  languages?: string[];
  skills?: string[];
  exclusions?: { value: string; scope: string }[];
}

export async function getAlerts(): Promise<AlertDto[]> {
  return apiClient<AlertDto[]>("/api/alerts");
}

export async function getAlert(id: number | string): Promise<AlertDto> {
  return apiClient<AlertDto>(`/api/alerts/${id}`);
}

export async function createAlert(payload: CreateAlertPayload): Promise<AlertDto> {
  return apiClient<AlertDto>("/api/alerts", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateAlert(id: number | string, payload: UpdateAlertPayload): Promise<AlertDto> {
  await apiClient<AlertDto>(`/api/alerts/${id}`, {
    method: "PUT",
    body: JSON.stringify({
      seniorities: payload.seniorities,
      languages: payload.languages,
    }),
  });

  if (payload.skills !== undefined) {
    await apiClient<AlertDto>(`/api/alerts/${id}/skills`, {
      method: "POST",
      body: JSON.stringify({ skills: payload.skills }),
    });
  }

  if (payload.exclusions !== undefined) {
    await apiClient<AlertDto>(`/api/alerts/${id}/exclusions`, {
      method: "POST",
      body: JSON.stringify({ exclusions: payload.exclusions }),
    });
  }

  return getAlert(id);
}

export async function deleteAlert(id: number | string): Promise<{ ok: boolean }> {
  return apiClient<{ ok: boolean }>(`/api/alerts/${id}`, {
    method: "DELETE",
  });
}
